import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import {
  PaymentOverviewAnalyticsData,
  PaymentOverviewAnalyticsParams,
  PaymentOverviewData,
  PaymentOverviewReservationChartData,
  PaymentSalesBreakdownParams,
  SalesBreakdownData,
} from './payment.types';

const getPaymentOverview = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<PaymentOverviewData>>(API_ROUTES.GET_PAYMENT_OVERVIEW)).data;
};

const getPaymentOverviewAnalytics = (client: AxiosInstance) => async (params: PaymentOverviewAnalyticsParams) => {
  return (
    await client.get<ApiResponse<PaymentOverviewAnalyticsData>>(API_ROUTES.GET_PAYMENT_OVERVIEW_ANALYTICS, { params })
  ).data;
};

const getPaymentOverviewReservationChart =
  (client: AxiosInstance) => async (params: PaymentOverviewAnalyticsParams) => {
    return (
      await client.get<ApiResponse<PaymentOverviewReservationChartData>>(
        API_ROUTES.GET_PAYMENT_OVERVIEW_RESERVATION_CHART,
        { params },
      )
    ).data;
  };

const getSalesBreakdown = (client: AxiosInstance) => async (params: PaymentSalesBreakdownParams) =>
  (
    await client.get<PaginatedApiResponse<SalesBreakdownData[]>>(API_ROUTES.GET_PAYMENT_SALES_BREAKDOWN, {
      params,
    })
  ).data;

export const paymentOverviewQueries = {
  all: () => ['payment-overview'],
  overview: () =>
    queryFactoryOptions<ApiResponse<PaymentOverviewData>>({
      queryKey: [...paymentOverviewQueries.all(), 'overview'],
      queryFn: (client) => getPaymentOverview(client),
    }),
  analytics: (params: PaymentOverviewAnalyticsParams) =>
    queryFactoryOptions<ApiResponse<PaymentOverviewAnalyticsData>>({
      queryKey: [...paymentOverviewQueries.all(), 'analytics', params],
      queryFn: (client) => () => getPaymentOverviewAnalytics(client)(params),
    }),
  reservationChart: (params: PaymentOverviewAnalyticsParams) =>
    queryFactoryOptions<ApiResponse<PaymentOverviewReservationChartData>>({
      queryKey: [...paymentOverviewQueries.all(), 'reservation-chart', params],
      queryFn: (client) => () => getPaymentOverviewReservationChart(client)(params),
    }),
};

export const salesBreakdownQueries = {
  all: () => ['payment-sales-breakdown'],

  list: (params: PaymentSalesBreakdownParams) =>
    queryFactoryOptions<PaginatedApiResponse<SalesBreakdownData[]>>({
      queryKey: [...salesBreakdownQueries.all(), 'list', params],
      queryFn: (client) => () => getSalesBreakdown(client)(params),
    }),
};
